import { useMemo } from 'react';
import Raven from 'raven-js';
import { Text } from 'foundations-components/components/Text';
import { CODE_BLOCK_REGEX, PARSE_CODE_BLOCK_REGEX } from 'chatspot-core/messages/code/CodeRegex';
import Markdown from './text/Markdown';
import ErrorSectionFormatter from './ErrorSectionFormatter';
import { jsx as _jsx } from "react/jsx-runtime";
const HtmlSectionFormatter = ({
  section: {
    text = ''
  }
}) => {
  const messageBlocks = useMemo(() => {
    const textBlocks = text.split(CODE_BLOCK_REGEX);
    return textBlocks.map((textBlock, index) => {
      const parsedCodeBlock = textBlock.match(PARSE_CODE_BLOCK_REGEX);

      // We don't support code blocks here to avoid a large dep on highlight.js
      if (parsedCodeBlock) {
        Raven.captureException(new Error('Cannot render code block in Copilot Preview'));

        /* eslint-disable-next-line react/jsx-key */
        return /*#__PURE__*/_jsx(ErrorSectionFormatter, {});
      }
      return /*#__PURE__*/_jsx(Markdown, {
        html: textBlock
      }, index);
    });
  }, [text]);
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    typography: "body-100",
    overflowWrap: "break-word",
    children: messageBlocks
  });
};
export default HtmlSectionFormatter;